<template>
    <form-row title="MLS #">
        <div class="sm:w-1/2">
            <input-text
                name="mls_number"
                :value="property.mls_number"
                placeholder="#"
                :read_only="read_only"
                @change="fetchMlsData"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        property: { default: () => ({}) },
        read_only: { default: false },
    },

    methods: {
        fetchMlsData(mls_number) {
            if (! mls_number) {
                return;
            }

            axios.get('/mls-lookup/' + mls_number)
                .then(response => {
                    if (response.data.data) {
                        this.$emit('mlsDataReceived', response.data.data);
                    }
                }).catch(error => {
                    console.log(error);
                });
        },
    },
}
</script>
